import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner8.png'
import _imports_2 from '../../assets/performance/bannerQF.png'
import _imports_3 from '../../assets/performance/nz_banner_deep.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-eeb773f0")

_pushScopeId("data-v-eeb773f0")
const _hoisted_1 = { style: {"flex":"1"} }
const _hoisted_2 = { style: {"box-sizing":"border-box","color":"black","padding":"20px 0"} }
const _hoisted_3 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_4 = { class: "testMain" }
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("模块函数配置")
const _hoisted_7 = { class: "module_djalog" }
const _hoisted_8 = { class: "dialog-content" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("只显示模块")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { style: {"display":"flex"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("添加一行")
const _hoisted_17 = {
  style: {"display":"flex","justify-content":"flex-start"},
  class: "add_input"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_19 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "提交", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "取消修改", -1)
const _hoisted_22 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_24 = { style: {"text-align":"right","margin-bottom":"5px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "editRecipient" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_38 = { class: "spacName" }
const _hoisted_39 = {
  key: 0,
  class: "banner",
  src: _imports_1,
  alt: ""
}
const _hoisted_40 = {
  key: 1,
  class: "banner",
  src: _imports_2,
  alt: ""
}
const _hoisted_41 = {
  key: 2,
  class: "banner",
  src: _imports_3,
  alt: ""
}
const _hoisted_42 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_43 = /*#__PURE__*/_createVNode("h5", {
  id: "report_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试概况 ")
], -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("一键清除text")
const _hoisted_45 = {
  class: "spacName",
  id: "problem_trend"
}
const _hoisted_46 = { style: {"width":"70%"} }
const _hoisted_47 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_48 = { style: {"display":"flex"} }
const _hoisted_49 = { style: {"margin-right":"10px"} }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold"} }, "当前版本：", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold"} }, "机型：", -1)
const _hoisted_52 = { style: {"margin-right":"10px"} }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold"} }, "对比版本：", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold"} }, "场景：", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { style: {"height":"22.5px"} }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 风险: ")
const _hoisted_57 = {
  style: {"mini-width":"70%","margin-bottom":"20px","width":"70%"},
  class: "gameTable_cpu_2"
}
const _hoisted_58 = {
  class: "problem_td",
  style: {"background":"#dae1f1","font-weight":"bold","color":"black","text-align":"center"}
}
const _hoisted_59 = /*#__PURE__*/_createVNode("td", { colspan: "2" }, "核心指标", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("td", null, "数据", -1)
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  key: 0,
  style: {"mini-width":"70%","margin-bottom":"10px","width":"70%"},
  class: "gameTable_cpu_2"
}
const _hoisted_68 = {
  class: "problem_td",
  style: {"background":"#dae1f1","font-weight":"bold","color":"black","text-align":"center"}
}
const _hoisted_69 = /*#__PURE__*/_createVNode("td", null, "重点卡顿问题", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("td", { colspan: "2" }, "异常指标", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("td", null, "数据(对比整局平均)", -1)
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_76 = /*#__PURE__*/_createVNode("h5", {
  id: "fps_scroll",
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("FPS ")
], -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" 阈值配置")
const _hoisted_78 = { class: "dialog-footer" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_81 = { class: "module_djalog" }
const _hoisted_82 = { class: "dialog-content configurationStyle" }
const _hoisted_83 = { class: "form-items" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_85 = { class: "check_style" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("变差就有风险")
const _hoisted_87 = { class: "check_style" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = {
  key: 2,
  style: {"margin":"0 10px"}
}
const _hoisted_90 = /*#__PURE__*/_createTextVNode("启用基线")
const _hoisted_91 = /*#__PURE__*/_createTextVNode("启用变化阈值")
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"350px"},
  id: "fps_iteration"
}, null, -1)
const _hoisted_100 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_101 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"350px"},
  id: "fps_inside"
}, null, -1)
const _hoisted_102 = { class: "gameTable_cpu" }
const _hoisted_103 = { style: {"font-weight":"bold"} }
const _hoisted_104 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_105 = { key: 0 }
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createVNode("h5", {
    id: "cpu_scroll",
    class: "TitleStyle",
    style: {"margin-bottom":"0px"}
  }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode("自定义数据 ")
  ])
], -1)
const _hoisted_107 = {
  style: {"height":"350px"},
  id: "custom"
}
const _hoisted_108 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_109 = /*#__PURE__*/_createVNode("h5", {
  id: "cpu_scroll",
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("CPU性能 ")
], -1)
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" 阈值配置")
const _hoisted_111 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"350px"},
  id: "cpu"
}, null, -1)
const _hoisted_112 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_113 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"450px"},
  id: "cpu_inside"
}, null, -1)
const _hoisted_114 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_115 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"450px"},
  id: "cpu_inside_freq"
}, null, -1)
const _hoisted_116 = { class: "gameTable_cpu" }
const _hoisted_117 = { style: {"font-weight":"bold"} }
const _hoisted_118 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_119 = {
  key: 1,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_120 = /*#__PURE__*/_createVNode("h5", {
  id: "cpu_scroll",
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("CPU线程占比 ")
], -1)
const _hoisted_121 = /*#__PURE__*/_createVNode("div", {
  id: "cpu_thread_iteration",
  style: {"height":"350px"}
}, null, -1)
const _hoisted_122 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_123 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"450px"},
  id: "cpu_thread"
}, null, -1)
const _hoisted_124 = { class: "gameTable_cpu" }
const _hoisted_125 = { style: {"font-weight":"bold"} }
const _hoisted_126 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_127 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_128 = /*#__PURE__*/_createVNode("h5", {
  id: "gpu_scroll",
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("GPU性能 ")
], -1)
const _hoisted_129 = /*#__PURE__*/_createTextVNode(" 阈值配置")
const _hoisted_130 = {
  style: {"height":"350px"},
  id: "gpu_iteration"
}
const _hoisted_131 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_132 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"450px"},
  id: "gpu_inside"
}, null, -1)
const _hoisted_133 = { class: "gameTable_cpu" }
const _hoisted_134 = { style: {"font-weight":"bold"} }
const _hoisted_135 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_136 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_137 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("线程耗时 ")
], -1)
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" 阈值配置")
const _hoisted_139 = {
  style: {"height":"350px"},
  id: "threadTrand"
}
const _hoisted_140 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_141 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"450px"},
  id: "thread_inside"
}, null, -1)
const _hoisted_142 = { class: "spacName gameTable_cpu" }
const _hoisted_143 = { style: {"font-weight":"bold"} }
const _hoisted_144 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_145 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_146 = /*#__PURE__*/_createVNode("h5", {
  id: "func_scroll",
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("模块函数耗时 ")
], -1)
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" 阈值配置")
const _hoisted_148 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_149 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_150 = {
  style: {"height":"450px"},
  id: "moudelTrand"
}
const _hoisted_151 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_152 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_153 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_154 = {
  style: 'height:' + 600 + 'px',
  id: "moudle_inside"
}
const _hoisted_155 = { style: {"display":"flex"} }
const _hoisted_156 = /*#__PURE__*/_createVNode("div", { style: {"height":"59px","line-height":"59px"} }, " 线程模块 ", -1)
const _hoisted_157 = /*#__PURE__*/_createVNode("h5", {
  id: "ms_scroll",
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("函数耗时堆栈 ")
], -1)
const _hoisted_158 = { class: "spacName" }
const _hoisted_159 = { id: "func_trend" }
const _hoisted_160 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_161 = { style: {"margin-top":"20px"} }
const _hoisted_162 = { class: "frames-info" }
const _hoisted_163 = /*#__PURE__*/_createTextVNode(" 全局 ")
const _hoisted_164 = { class: "frames-num" }
const _hoisted_165 = /*#__PURE__*/_createTextVNode(" 帧， 时长 ")
const _hoisted_166 = { class: "frames-num" }
const _hoisted_167 = /*#__PURE__*/_createTextVNode(" ms， 平均帧率 ")
const _hoisted_168 = { class: "frames-num" }
const _hoisted_169 = /*#__PURE__*/_createTextVNode(" fps， 平均每帧 ")
const _hoisted_170 = { class: "frames-num" }
const _hoisted_171 = /*#__PURE__*/_createTextVNode(" ms ")
const _hoisted_172 = { class: "frames-info" }
const _hoisted_173 = /*#__PURE__*/_createTextVNode(" 选中 ")
const _hoisted_174 = { class: "frames-num" }
const _hoisted_175 = /*#__PURE__*/_createTextVNode(" 帧， 帧序列 ")
const _hoisted_176 = { class: "frames-num" }
const _hoisted_177 = /*#__PURE__*/_createTextVNode("， 时长 ")
const _hoisted_178 = { class: "frames-num" }
const _hoisted_179 = /*#__PURE__*/_createTextVNode(" ms， 平均帧率 ")
const _hoisted_180 = { class: "frames-num" }
const _hoisted_181 = /*#__PURE__*/_createTextVNode(" fps， 平均每帧 ")
const _hoisted_182 = { class: "frames-num" }
const _hoisted_183 = /*#__PURE__*/_createTextVNode(" ms/frame ")
const _hoisted_184 = {
  key: 0,
  class: "frames-info",
  style: {"margin-top":"10px"}
}
const _hoisted_185 = /*#__PURE__*/_createTextVNode(" 选中时间段 ")
const _hoisted_186 = { class: "frames-num" }
const _hoisted_187 = {
  key: 0,
  style: {"margin-top":"5px"}
}
const _hoisted_188 = /*#__PURE__*/_createTextVNode("添加选中区域到重点卡顿问题")
const _hoisted_189 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_190 = {
  class: "pos",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_191 = /*#__PURE__*/_createVNode("div", {
  id: "analyse",
  style: {"height":"416px","width":"100%"}
}, null, -1)
const _hoisted_192 = /*#__PURE__*/_createVNode("div", {
  id: "history_trend",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_193 = { class: "spacName" }
const _hoisted_194 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_195 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_196 = /*#__PURE__*/_createTextVNode("全部收起")
const _hoisted_197 = { style: {"width":"100%","height":"35px","display":"flex","position":"relative","border-radius":"2%"} }
const _hoisted_198 = { class: "pos_box" }
const _hoisted_199 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_200 = { style: {"width":"50%","margin-right":"20px"} }
const _hoisted_201 = { style: {"width":"5.5%"} }
const _hoisted_202 = { style: {"margin-left":"auto","width":"25%"} }
const _hoisted_203 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_204 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_205 = { ref: "container" }
const _hoisted_206 = { id: "chart" }
const _hoisted_207 = { class: "tree-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_QuillEditor = _resolveComponent("QuillEditor")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_el_form, {
                    class: "anaysis_class",
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_5, [
                        _createVNode(_component_el_form_item, { label: "是否自动" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.auto_query,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.auto_query = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (
                        _ctx.versionChange(false, ['type', 'scene', 'device'])
                      )),
                              "collapse-tags": "",
                              "collapse-tags-tooltip": ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.auto_data, (item, k) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: k,
                                    label: item.label,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (_ctx.report_data.length != 1)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              label: "父类型"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  onChange: _cache[3] || (_cache[3] = ($event: any) => (
                        _ctx.versionChange(
                          false,
                          ['type', 'scene', 'device'],
                          (_ctx.subtype_query = '')
                        )
                      )),
                                  modelValue: _ctx.type_query,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.type_query = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_data, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.report_data.length != 1)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              label: "子类型"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (
                        _ctx.versionChange(false, ['type', 'scene', 'device'])
                      )),
                                  key: _ctx.sub_key,
                                  filterable: "",
                                  modelValue: _ctx.subtype_query,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.subtype_query = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sub_data, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tableAddShow = true)),
                              type: "primary"
                            }, {
                              default: _withId(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.tableAddShow,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.tableAddShow = $event)),
                      width: "80%",
                      class: "custom-dialog",
                      height: "auto"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_8, [
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.conFig.is_show_function_check,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.conFig.is_show_function_check = $event))
                          }, {
                            default: _withId(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_table, {
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                            data: _ctx.conFig.module_list
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, { label: "线程" }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(scope.row.thread), 1))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: scope.row.thread,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.thread = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              (_ctx.localProject != 7)
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 0,
                                    label: "so"
                                  }, {
                                    default: _withId((scope) => [
                                      (!scope.row.edit)
                                        ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(scope.row.so), 1))
                                        : (_openBlock(), _createBlock(_component_el_input, {
                                            key: 1,
                                            modelValue: scope.row.so,
                                            "onUpdate:modelValue": ($event: any) => (scope.row.so = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_table_column, { label: "模块/函数名" }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(scope.row.module), 1))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: scope.row.module,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.module = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "是否函数",
                                width: "80"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_checkbox, {
                                    disabled: !scope.row.edit,
                                    modelValue: scope.row.func_check,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.func_check = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "父模块" }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(scope.row.parent), 1))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: scope.row.parent,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.parent = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "函数列表",
                                width: "400"
                              }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.functions, (item) => {
                                          return (_openBlock(), _createBlock("div", { key: item }, _toDisplayString(item), 1))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        rows: "10",
                                        type: "textarea",
                                        modelValue: scope.row.functions_string,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.functions_string = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "趋势图",
                                width: "80"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_checkbox, {
                                    disabled: !scope.row.edit,
                                    modelValue: scope.row.trend_check,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.trend_check = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "表格",
                                width: "80"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_checkbox, {
                                    disabled: !scope.row.edit,
                                    modelValue: scope.row.show_check,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.show_check = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "操作" }, {
                                default: _withId((scope) => [
                                  _createVNode("div", _hoisted_15, [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      size: "mini",
                                      onClick: ($event: any) => (_ctx.edit1(scope.row))
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(scope.row.edit ? "确认" : "修改"), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      size: "mini",
                                      onClick: ($event: any) => (_ctx.clear(scope.row, scope.$index))
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(scope.row.edit ? "取消" : "删除"), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"]),
                          (!_ctx.addShow)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "mini",
                                style: {"margin-top":"10px"},
                                type: "primary",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addRow()))
                              }, {
                                default: _withId(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.addShow)
                            ? (_openBlock(), _createBlock(_component_el_form, {
                                key: 1,
                                style: {"margin":"10px 0"},
                                size: "mini",
                                "label-position": "top"
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_17, [
                                    _createVNode(_component_el_form_item, {
                                      label: "线程",
                                      style: {"margin-right":"25px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.add_row_data.so = '')),
                                          modelValue: _ctx.add_row_data.thread,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.add_row_data.thread = $event)),
                                          id: "old_version",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thread_add, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "so",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.add_row_data.so,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.add_row_data.so = $event)),
                                          id: "old_version",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.so_list[_ctx.add_row_data.thread], (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "模块/函数名",
                                      style: {"margin-right":"45px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.add_row_data.moudel,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.add_row_data.moudel = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "是否函数",
                                      width: "50",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.add_row_data.func_check,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.add_row_data.func_check = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "父模块",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.add_row_data.parent,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.add_row_data.parent = $event)),
                                          id: "old_version",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.parentList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "函数名",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          type: "textarea",
                                          rows: "1",
                                          modelValue: _ctx.add_row_data.functions_string,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.add_row_data.functions_string = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "趋势图",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.add_row_data.trend_check,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.add_row_data.trend_check = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "表格",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.add_row_data.show_check,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.add_row_data.show_check = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "按钮" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          size: "mini",
                                          type: "primary",
                                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addList()))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_18
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_19, [
                            _createVNode(_component_el_popconfirm, {
                              title: "确认提交？",
                              onConfirm: _cache[20] || (_cache[20] = ($event: any) => (_ctx.submit_edit())),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_20
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认是否放弃本次修改？",
                              onConfirm: _cache[21] || (_cache[21] = ($event: any) => (_ctx.submit_cancellation())),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "info",
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_21
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "anaysis_class"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_22, [
                        _createVNode(_component_el_form_item, {
                          class: "version_input",
                          label: "场景"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.dataConsumeOptions.scene,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.dataConsumeOptions.scene = $event)),
                              onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.versionChange(false, ['scene', 'device']))),
                              placeholder: "请选择",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.scene_id,
                                    label: item.scene__chinese,
                                    value: item.scene_id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "version_input",
                          label: "机型"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.dataConsumeOptions.device,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.dataConsumeOptions.device = $event)),
                              onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.versionChange(false, ['device']))),
                              placeholder: "请选择",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.device_id,
                                    label: 
                          item.device__level +
                          '档机-' +
                          item.device__model__name +
                          '-' +
                          item.device__model__model +
                          '-' +
                          item.device__UUID
                        ,
                                    value: item.device_id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "version_input",
                          label: "版本"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.dataConsumeOptions.version,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.dataConsumeOptions.version = $event)),
                              placeholder: "请选择",
                              onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.versionChange(true))),
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.chinese,
                                    value: item.chinese
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "version_input",
                          label: "对比版本"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.dataConsumeOptions.old_verson,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.dataConsumeOptions.old_verson = $event)),
                              placeholder: "请选择",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOldOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.chinese,
                                    value: item.chinese
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              onClick: _ctx.confirm,
                              type: "primary"
                            }, {
                              default: _withId(() => [
                                _hoisted_23
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_24, [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      type: "primary",
                      onClick: _ctx.sendOut,
                      disabled: _ctx.saveShow,
                      class: "down_img"
                    }, {
                      default: _withId(() => [
                        _hoisted_25,
                        _hoisted_26
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        _createVNode("div", _hoisted_28, [
                          _createVNode(_component_el_form, {
                            "label-position": "left",
                            "label-width": "100px",
                            model: _ctx.formMail,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formMail.title,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.formMail.title = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                    content: _withId(() => [
                                      _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                    ]),
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.formMail.Sender,
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.formMail.Sender = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                    content: _withId(() => [
                                      _hoisted_29,
                                      _hoisted_30,
                                      _hoisted_31,
                                      _hoisted_32,
                                      _hoisted_33,
                                      _hoisted_34,
                                      _hoisted_35
                                    ]),
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.formMail.addressee,
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.formMail.addressee = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formMail.CC_List,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_popconfirm, {
                                title: "确认发送报告吗？",
                                onConfirm: _cache[34] || (_cache[34] = ($event: any) => (_ctx.save_report(false))),
                                placement: "top"
                              }, {
                                reference: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    disabled: _ctx.get_is_super,
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_tooltip, {
                                        effect: "dark",
                                        content: "暂无管理员权限",
                                        placement: "top",
                                        disabled: !_ctx.get_is_super
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_36
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                size: "mini",
                                type: "info",
                                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.edit = false))
                              }, {
                                default: _withId(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"])
                        ]),
                        _createVNode("div", _hoisted_38, [
                          (_ctx.localProject != 7 && _ctx.localProject != 12)
                            ? (_openBlock(), _createBlock("img", _hoisted_39))
                            : _createCommentVNode("", true),
                          (_ctx.localProject == 7)
                            ? (_openBlock(), _createBlock("img", _hoisted_40))
                            : _createCommentVNode("", true),
                          (_ctx.localProject == 12)
                            ? (_openBlock(), _createBlock("img", _hoisted_41))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_42, [
                      _hoisted_43,
                      (_ctx.name_token.includes(_ctx.delete_text))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: _ctx.delete_btn_text,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _hoisted_44
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_45, [
                      _createVNode("div", _hoisted_46, [
                        _createVNode("div", _hoisted_47, [
                          _createVNode("div", _hoisted_48, [
                            _createVNode("div", _hoisted_49, [
                              _createVNode("div", null, [
                                _hoisted_50,
                                _createTextVNode(_toDisplayString(_ctx.report_data_list?.version), 1)
                              ]),
                              _createVNode("div", null, [
                                _hoisted_51,
                                _createTextVNode(_toDisplayString(_ctx.report_data_list?.device_level +
                              "-" +
                              _ctx.report_data_list?.device_name), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_52, [
                              _createVNode("div", null, [
                                _hoisted_53,
                                _createTextVNode(_toDisplayString(_ctx.report_data_list?.old_version), 1)
                              ]),
                              _createVNode("div", null, [
                                _hoisted_54,
                                _createTextVNode(_toDisplayString(_ctx.report_data_list?.scene), 1)
                              ])
                            ]),
                            _createVNode("div", null, [
                              _hoisted_55,
                              _createVNode("div", null, [
                                _hoisted_56,
                                (!_ctx.edit_show)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      class: 
                                _ctx.risk == '高风险'
                                  ? 'com_risk_red'
                                  : 'com_risk_green'
                              
                                    }, _toDisplayString(_ctx.risk), 3))
                                  : (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      size: "mini",
                                      modelValue: _ctx.risk,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.risk = $event))
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.risk_list_edit, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]))
                              ])
                            ])
                          ]),
                          (_ctx.edit_show_text)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                style: {"margin-left":"20px","color":"#409eff","cursor":"pointer"},
                                onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.edit_text()))
                              }, _toDisplayString(_ctx.edit_show ? "提交" : "编辑"), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createVNode("table", _hoisted_57, [
                          _createVNode("tr", _hoisted_58, [
                            _hoisted_59,
                            _hoisted_60,
                            (_ctx.edit_show)
                              ? (_openBlock(), _createBlock("td", _hoisted_61, [
                                  _createVNode("div", {
                                    onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.operate && _ctx.operate(...args))),
                                    class: "link-span"
                                  }, "添加")
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.table_test_overview, (item, index) => {
                            return (_openBlock(), _createBlock("tr", {
                              class: "problem_td_body",
                              key: index
                            }, [
                              (item.index_detail_rowspan)
                                ? (_openBlock(), _createBlock("td", {
                                    key: 0,
                                    rowspan: item.index_detail_rowspan
                                  }, [
                                    (!item.edit)
                                      ? (_openBlock(), _createBlock("div", _hoisted_62, [
                                          _createVNode("span", null, _toDisplayString(item.index_detail), 1)
                                        ]))
                                      : (_openBlock(), _createBlock(_component_el_input, {
                                          key: 1,
                                          size: "mini",
                                          onBlur: ($event: any) => (_ctx.problemChange(item, index)),
                                          modelValue: item.index_detail,
                                          "onUpdate:modelValue": ($event: any) => (item.index_detail = $event)
                                        }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue"]))
                                  ], 8, ["rowspan"]))
                                : _createCommentVNode("", true),
                              _createVNode("td", null, [
                                (!item.edit_name)
                                  ? (_openBlock(), _createBlock("div", _hoisted_63, _toDisplayString(item.index_detail_name), 1))
                                  : (_openBlock(), _createBlock(_component_el_input, {
                                      key: 1,
                                      size: "mini",
                                      onBlur: ($event: any) => (_ctx.problemNameChange(item, index)),
                                      modelValue: item.index_detail_name,
                                      "onUpdate:modelValue": ($event: any) => (item.index_detail_name = $event)
                                    }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue"]))
                              ]),
                              _createVNode("td", {
                                style: 
                            'background:' +
                            (item.value == '对比上版本' ||
                            item.value == '对比整局平均'
                              ? '#D6DCE4'
                              : '#fff')
                          
                              }, [
                                (!item.edit_vale && !item.text_quillEditor)
                                  ? (_openBlock(), _createBlock("div", _hoisted_64, [
                                      _createVNode("span", {
                                        style: 'color:' + item.color
                                      }, _toDisplayString(item.value === null || item.value === ""
                                ? "--"
                                : item.value), 5),
                                      _createVNode("span", {
                                        style: 
                                'color:' +
                                item.color_new +
                                ';font-weight:' +
                                (item.color_new == '#00b050' ? 'bold' : '')
                              
                                      }, _toDisplayString(item.text), 5)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.edit_vale)
                                  ? (_openBlock(), _createBlock("span", _hoisted_65, [
                                      _createVNode(_component_QuillEditor, {
                                        content: item.text_quillEditor,
                                        "onUpdate:content": ($event: any) => (item.text_quillEditor = $event),
                                        contentType: "html",
                                        options: _ctx.editorOption,
                                        theme: "snow",
                                        onBlur: ($event: any) => (_ctx.handleBlur(item))
                                      }, null, 8, ["content", "onUpdate:content", "options", "onBlur"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.text_quillEditor && !item.edit_vale)
                                  ? (_openBlock(), _createBlock("p", {
                                      key: 2,
                                      innerHTML: item.text_quillEditor,
                                      class: "text_detail"
                                    }, null, 8, ["innerHTML"]))
                                  : _createCommentVNode("", true)
                              ], 4),
                              (_ctx.edit_show)
                                ? (_openBlock(), _createBlock("td", _hoisted_66, [
                                    _createVNode("span", {
                                      class: "link-span",
                                      onClick: ($event: any) => (_ctx.operate(item, index))
                                    }, " 删除", 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 512), [
                          [_directive_loading, _ctx.test_loading]
                        ]),
                        (_ctx.table_test_overview_important?.length > 0)
                          ? _withDirectives((_openBlock(), _createBlock("table", _hoisted_67, [
                              _createVNode("tr", _hoisted_68, [
                                _hoisted_69,
                                _hoisted_70,
                                _hoisted_71,
                                (_ctx.edit_show)
                                  ? (_openBlock(), _createBlock("td", _hoisted_72, [
                                      false
                                        ? (_openBlock(), _createBlock("div", {
                                            key: 0,
                                            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.operate('add'))),
                                            class: "link-span"
                                          }, " 添加 "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.table_test_overview_important, (item, index) => {
                                return (_openBlock(), _createBlock("tr", {
                                  style: {"text-align":"left"},
                                  class: "problem_td_body",
                                  key: index
                                }, [
                                  (item.index_name_rowspan)
                                    ? (_openBlock(), _createBlock("td", {
                                        key: 0,
                                        style: 
                            'background:' +
                            (item.index_name == '' ? '#D6DCE4' : '#fff')
                          ,
                                        rowspan: item.index_name_rowspan
                                      }, [
                                        (!item.edit)
                                          ? (_openBlock(), _createBlock("div", {
                                              key: 0,
                                              onDblclick: ($event: any) => (
                              _ctx.edit_show ? _ctx.edit_table(item, index) : _ctx.returnBtn()
                            )
                                            }, _toDisplayString(item.index_name), 41, ["onDblclick"]))
                                          : (_openBlock(), _createBlock(_component_el_input, {
                                              key: 1,
                                              size: "mini",
                                              onBlur: ($event: any) => (_ctx.problemChange(item, index)),
                                              modelValue: item.index_name,
                                              "onUpdate:modelValue": ($event: any) => (item.index_name = $event)
                                            }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue"]))
                                      ], 12, ["rowspan"]))
                                    : _createCommentVNode("", true),
                                  (item.index_detail_rowspan)
                                    ? (_openBlock(), _createBlock("td", {
                                        key: 1,
                                        rowspan: item.index_detail_rowspan
                                      }, [
                                        (!item.edit_detail)
                                          ? (_openBlock(), _createBlock("div", {
                                              key: 0,
                                              onDblclick: ($event: any) => (
                              _ctx.edit_show
                                ? _ctx.edit_table_detail(item, index)
                                : _ctx.returnBtn()
                            )
                                            }, [
                                              _createVNode("span", null, _toDisplayString(item.index_detail), 1)
                                            ], 40, ["onDblclick"]))
                                          : (_openBlock(), _createBlock(_component_el_input, {
                                              key: 1,
                                              size: "mini",
                                              onBlur: ($event: any) => (_ctx.problemDetailChange(item, index)),
                                              modelValue: item.index_detail,
                                              "onUpdate:modelValue": ($event: any) => (item.index_detail = $event)
                                            }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue"]))
                                      ], 8, ["rowspan"]))
                                    : _createCommentVNode("", true),
                                  _createVNode("td", null, [
                                    (!item.edit_name)
                                      ? (_openBlock(), _createBlock("div", {
                                          key: 0,
                                          onDblclick: ($event: any) => (
                              _ctx.edit_show
                                ? _ctx.edit_table_name(item, index)
                                : _ctx.returnBtn()
                            )
                                        }, _toDisplayString(item.index_detail_name), 41, ["onDblclick"]))
                                      : (_openBlock(), _createBlock(_component_el_input, {
                                          key: 1,
                                          size: "mini",
                                          onBlur: ($event: any) => (_ctx.problemNameChange(item, index)),
                                          modelValue: item.index_detail_name,
                                          "onUpdate:modelValue": ($event: any) => (item.index_detail_name = $event)
                                        }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue"]))
                                  ]),
                                  _createVNode("td", {
                                    style: 
                            'background:' +
                            (item.value == '对比上版本' ||
                            item.value == '对比整局平均'
                              ? '#D6DCE4'
                              : '#fff')
                          
                                  }, [
                                    (!item.edit_vale && !item.text_quillEditor)
                                      ? (_openBlock(), _createBlock("div", {
                                          key: 0,
                                          onDblclick: ($event: any) => (
                              _ctx.edit_show
                                ? _ctx.edit_table_value(item, index)
                                : _ctx.returnBtn()
                            )
                                        }, [
                                          _createVNode("span", {
                                            style: 'color:' + item.color
                                          }, _toDisplayString(item.value === null || item.value === ""
                                ? "--"
                                : item.value), 5),
                                          _createVNode("span", {
                                            style: 
                                'color:' +
                                item.color_new +
                                ';font-weight:' +
                                (item.color_new == '#00b050' ? 'bold' : '')
                              
                                          }, _toDisplayString(item.text), 5)
                                        ], 40, ["onDblclick"]))
                                      : _createCommentVNode("", true),
                                    (item.edit_vale)
                                      ? (_openBlock(), _createBlock("span", _hoisted_73, [
                                          _createVNode(_component_QuillEditor, {
                                            content: item.text_quillEditor,
                                            "onUpdate:content": ($event: any) => (item.text_quillEditor = $event),
                                            contentType: "html",
                                            options: _ctx.editorOption,
                                            theme: "snow",
                                            onBlur: ($event: any) => (_ctx.handleBlur(item))
                                          }, null, 8, ["content", "onUpdate:content", "options", "onBlur"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.text_quillEditor && !item.edit_vale)
                                      ? (_openBlock(), _createBlock("p", {
                                          key: 2,
                                          onDblclick: ($event: any) => (_ctx.edit_table_value_html(item, index)),
                                          innerHTML: item.text_quillEditor,
                                          class: "text_detail"
                                        }, null, 40, ["onDblclick", "innerHTML"]))
                                      : _createCommentVNode("", true)
                                  ], 4),
                                  (_ctx.edit_show)
                                    ? (_openBlock(), _createBlock("td", _hoisted_74, [
                                        _createVNode("span", {
                                          class: "link-span",
                                          onClick: ($event: any) => (_ctx.operate('重点问题卡顿', index))
                                        }, " 删除 ", 8, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ], 512)), [
                              [_directive_loading, _ctx.test_loading]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        style: {"margin-left":"20px"},
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.configurationShow = true))
                      }, {
                        default: _withId(() => [
                          _hoisted_77
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", null, [
                      _createVNode(_component_el_dialog, {
                        width: "615px",
                        modelValue: _ctx.operateShow,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.operateShow = $event))
                      }, {
                        footer: _withId(() => [
                          _createVNode("span", _hoisted_78, [
                            _createVNode(_component_el_button, {
                              size: "small",
                              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.resetAddForm('ruleaddForm'))),
                              type: "info"
                            }, {
                              default: _withId(() => [
                                _hoisted_79
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "small",
                              type: "primary",
                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.submitAddForm()))
                            }, {
                              default: _withId(() => [
                                _hoisted_80
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini",
                            "label-position": "top"
                          }, {
                            default: _withId(() => [
                              (_ctx.overviewShow)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    style: {"width":"150px"},
                                    label: "重点卡顿问题"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.overview.risk,
                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.overview.risk = $event)),
                                        placeholder: "请选择",
                                        filterable: "",
                                        onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.overview.type = ''))
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.risk_type_new, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item,
                                              label: item,
                                              value: item
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, {
                                style: {"width":"150px"},
                                label: "指标类型"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.overview.type,
                                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.overview.type = $event)),
                                    placeholder: "请选择",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.indicator_type, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                style: {"width":"150px"},
                                label: "指标项"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.overview.term,
                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.overview.term = $event)),
                                    placeholder: "请选择",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.indicator_term, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_81, [
                      _createVNode(_component_el_dialog, {
                        modelValue: _ctx.configurationShow,
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.configurationShow = $event)),
                        width: "70%",
                        class: "custom-dialog",
                        height: "auto"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_82, [
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_83, [
                                  _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        onChange: _ctx.configChange,
                                        modelValue: _ctx.configuration_form.scene_id,
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.configuration_form.scene_id = $event)),
                                        placeholder: "请选择",
                                        filterable: ""
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_old_table, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.scene_id,
                                              label: item.scene__chinese,
                                              value: item.scene_id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["onChange", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "选择平台" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        onChange: _ctx.configChange,
                                        modelValue: _ctx.configuration_form.moudle,
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.configuration_form.moudle = $event)),
                                        placeholder: "选择平台",
                                        filterable: ""
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item,
                                              label: item,
                                              value: item
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["onChange", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_el_form_item, { class: "save-button" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _ctx.save_button
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_84
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode("div", _hoisted_85, [
                              _createVNode(_component_el_checkbox, {
                                onChange: _cache[50] || (_cache[50] = ($event: any) => (
                            _ctx.is_bad_risk == true
                              ? (_ctx.threshold_check = false)
                              : (_ctx.threshold_check = _ctx.threshold_check)
                          )),
                                modelValue: _ctx.is_bad_risk,
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.is_bad_risk = $event))
                              }, {
                                default: _withId(() => [
                                  _hoisted_86
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createVNode("div", _hoisted_87, [
                              (!_ctx.baseline_check)
                                ? (_openBlock(), _createBlock("span", _hoisted_88, "添加基线列"))
                                : (_openBlock(), _createBlock("span", {
                                    key: 1,
                                    style: {"color":"#409eff","cursor":"pointer"},
                                    onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.addRow_baseline()))
                                  }, "添加基线列")),
                              (!_ctx.threshold_check)
                                ? (_openBlock(), _createBlock("span", _hoisted_89, "添加变化阈值列"))
                                : (_openBlock(), _createBlock("span", {
                                    key: 3,
                                    style: {"margin":"0 10px","color":"#409eff","cursor":"pointer"},
                                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.addRow_threshold()))
                                  }, "添加变化阈值列")),
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.baseline_check,
                                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.baseline_check = $event))
                              }, {
                                default: _withId(() => [
                                  _hoisted_90
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_el_checkbox, {
                                disabled: _ctx.is_bad_risk,
                                modelValue: _ctx.threshold_check,
                                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.threshold_check = $event))
                              }, {
                                default: _withId(() => [
                                  _hoisted_91
                                ]),
                                _: 1
                              }, 8, ["disabled", "modelValue"])
                            ]),
                            _createVNode(_component_el_table, {
                              border: "",
                              size: "mini",
                              "header-cell-style": {
                          background: '#5D99D5',
                          color: '#fff',
                        },
                              "cell-style": _ctx.cellStyle2,
                              data: _ctx.configuration_table_data
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  width: "120",
                                  label: "指标"
                                }, {
                                  default: _withId((scope) => [
                                    (
                                scope.$index == 5 &&
                                (_ctx.baseline_check || _ctx.threshold_check)
                              )
                                      ? (_openBlock(), _createBlock(_component_el_input, {
                                          key: 0,
                                          modelValue: scope.row.name,
                                          "onUpdate:modelValue": ($event: any) => (scope.row.name = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createBlock("span", _hoisted_92, _toDisplayString(scope.row.name), 1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, { label: "基线" }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_baseline, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        width: "150",
                                        key: index
                                      }, {
                                        header: _withId(() => [
                                          (!_ctx.baseline_check)
                                            ? (_openBlock(), _createBlock("div", _hoisted_93, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                  return (_openBlock(), _createBlock("span", {
                                                    style: 
                                    'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                    _ctx.gear_position.filter((c) => c.value == i)[0]
                                      .background
                                  ,
                                                    key: i
                                                  }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                      .name), 5))
                                                }), 128))
                                              ]))
                                            : (_openBlock(), _createBlock(_component_el_select, {
                                                key: 1,
                                                modelValue: item.value,
                                                "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                                placeholder: "请选择",
                                                multiple: "",
                                                size: "mini",
                                                "collapse-tags": "",
                                                "collapse-tags-tooltip": ""
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                    _ctx.configuration_table_baseline,
                                    _ctx.gear_position_all,
                                    index
                                  ), (item, k) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: k,
                                                      label: item.name,
                                                      value: item.value,
                                                      disabled: item.disabled
                                                    }, null, 8, ["label", "value", "disabled"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                        ]),
                                        default: _withId((scope) => [
                                          (!_ctx.baseline_check && scope.row.name != '')
                                            ? (_openBlock(), _createBlock("span", _hoisted_94, _toDisplayString(scope.row.baseline[index]), 1))
                                            : (
                                  !_ctx.baseline_check && scope.row.name === ''
                                )
                                              ? (_openBlock(), _createBlock("span", _hoisted_95, _toDisplayString(scope.row.baseline[index]), 1))
                                              : (
                                  _ctx.baseline_check && scope.row.name != ''
                                )
                                                ? (_openBlock(), _createBlock(_component_el_input, {
                                                    key: 2,
                                                    modelValue: scope.row.baseline[index],
                                                    "onUpdate:modelValue": ($event: any) => (scope.row.baseline[index] = $event)
                                                  }, {
                                                    default: _withId(() => [
                                                      _createTextVNode(_toDisplayString(scope.row.baseline[index]), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                                : (
                                  _ctx.baseline_check && scope.row.name == ''
                                )
                                                  ? (_openBlock(), _createBlock("span", {
                                                      key: 3,
                                                      style: {"color":"#409eff","cursor":"pointer"},
                                                      onClick: ($event: any) => (_ctx.delete_baseline(index))
                                                    }, _toDisplayString(scope.row.baseline[index]), 9, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, { label: "变化阈值" }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_threshold, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        width: "150",
                                        key: index
                                      }, {
                                        header: _withId(() => [
                                          (!_ctx.threshold_check)
                                            ? (_openBlock(), _createBlock("div", _hoisted_96, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                  return (_openBlock(), _createBlock("span", {
                                                    style: 
                                    'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                    _ctx.gear_position.filter((c) => c.value == i)[0]
                                      .background
                                  ,
                                                    key: i
                                                  }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                      .name), 5))
                                                }), 128))
                                              ]))
                                            : (_openBlock(), _createBlock(_component_el_select, {
                                                key: 1,
                                                modelValue: item.value,
                                                "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                                placeholder: "请选择",
                                                multiple: "",
                                                size: "mini",
                                                "collapse-tags": "",
                                                "collapse-tags-tooltip": ""
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                    _ctx.configuration_table_threshold,
                                    _ctx.gear_position_all_threshold,
                                    index
                                  ), (item, k) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: k,
                                                      label: item.name,
                                                      value: item.value,
                                                      disabled: item.disabled
                                                    }, null, 8, ["label", "value", "disabled"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                        ]),
                                        default: _withId((scope) => [
                                          (!_ctx.threshold_check && scope.row.name != '')
                                            ? (_openBlock(), _createBlock("span", _hoisted_97, _toDisplayString(scope.row.threshold[index]), 1))
                                            : (
                                  !_ctx.threshold_check && scope.row.name == ''
                                )
                                              ? (_openBlock(), _createBlock("span", _hoisted_98, _toDisplayString(scope.row.threshold[index]), 1))
                                              : (
                                  _ctx.threshold_check && scope.row.name != ''
                                )
                                                ? (_openBlock(), _createBlock(_component_el_input, {
                                                    key: 2,
                                                    modelValue: scope.row.threshold[index],
                                                    "onUpdate:modelValue": ($event: any) => (scope.row.threshold[index] = $event)
                                                  }, {
                                                    default: _withId(() => [
                                                      _createTextVNode(_toDisplayString(scope.row.threshold[index]), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                                : (
                                  _ctx.threshold_check && scope.row.name == ''
                                )
                                                  ? (_openBlock(), _createBlock("span", {
                                                      key: 3,
                                                      onClick: ($event: any) => (_ctx.delete_threshold(index)),
                                                      style: {"color":"#409eff","cursor":"pointer"}
                                                    }, _toDisplayString(scope.row.threshold[index]), 9, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["cell-style", "data"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_el_tabs, {
                      type: "card",
                      class: "demo-tabs spacName",
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.activeName = $event)),
                      onTabClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.handleClick_fps('fps')))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "迭代趋势",
                          name: "first",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _hoisted_99
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.fps_loading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "局内趋势",
                          name: "second",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_100, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fps_list, (item, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: index,
                                      style: {
                            background: item.color,
                            width: item.width,
                          }
                                    }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                  }), 128))
                                ]),
                                _hoisted_101
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.fps_loading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "详细数据",
                          name: "third"
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode("table", _hoisted_102, [
                              _createVNode("thead", _hoisted_103, [
                                _createVNode("tr", null, [
                                  _hoisted_104,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params, (item) => {
                                    return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.name), 1))
                                  }), 128))
                                ])
                              ]),
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_usage_data, (v) => {
                                  return (_openBlock(), _createBlock("tr", { key: v }, [
                                    _createVNode("td", null, _toDisplayString(v.label), 1),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params, (item) => {
                                      return (_openBlock(), _createBlock("td", { key: item }, [
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_color(item.value, v.new[item.value])[0]
                              
                                        }, _toDisplayString(v.new[item.value]), 5),
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_color(
                                  item.value,
                                  v.new[item.value],
                                  v.old[item.value]
                                )[1]
                              
                                        }, "(" + _toDisplayString(_ctx.getNum(
                                  v.new[item.value],
                                  v.old[item.value],
                                  item.value
                                )) + ")", 5)
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ], 512), [
                              [_directive_loading, _ctx.fps_loading]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.localProject == 7 && !_ctx.customTreand?.is_null)
                      ? (_openBlock(), _createBlock("div", _hoisted_105, [
                          _hoisted_106,
                          _createVNode(_component_el_tabs, {
                            type: "card",
                            class: "demo-tabs spacName",
                            modelValue: _ctx.custom_activeName,
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.custom_activeName = $event))
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_tab_pane, {
                                label: "局外趋势",
                                name: "first_custom",
                                style: {"padding":"10px"}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_card, null, {
                                    default: _withId(() => [
                                      _withDirectives(_createVNode("div", _hoisted_107, null, 512), [
                                        [_directive_loading, _ctx.cpu_loading]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_tab_pane, {
                                label: "详细数据",
                                name: "second_custom"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_table, {
                                    data: _ctx.custom_table,
                                    border: "",
                                    size: "mini",
                                    "header-cell-style": {
                          background: '#5D99D5',
                          color: '#fff',
                        }
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_table_column, { label: "测试场景" }, {
                                        default: _withId((scope) => [
                                          _createTextVNode(_toDisplayString(scope.row.label), 1)
                                        ]),
                                        _: 1
                                      }),
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.custom_text, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                          label: item,
                                          key: item
                                        }, {
                                          default: _withId((scope) => [
                                            _createTextVNode(_toDisplayString(scope.row.new[item]), 1),
                                            _createVNode("span", null, "(" + _toDisplayString(_ctx.getNum(
                                  scope.row.new[item],
                                  scope.row.old[item]
                                )) + ")", 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["data"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_108, [
                      _hoisted_109,
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        style: {"margin-left":"20px"},
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.configurationShow = true))
                      }, {
                        default: _withId(() => [
                          _hoisted_110
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_el_tabs, {
                      type: "card",
                      class: "demo-tabs spacName",
                      modelValue: _ctx.cpu_activeName,
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.cpu_activeName = $event)),
                      onTabClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.handleClick_fps('cpu')))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "迭代趋势",
                          name: "first_cpu",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _hoisted_111
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.cpu_loading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "局内趋势",
                          name: "second_cpu",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode(_component_el_card, {
                              style: {"position":"relative","width":"100%"},
                              class: "spacName"
                            }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_112, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_list, (item, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: index,
                                      style: {
                            background: item.color,
                            width: item.width,
                          }
                                    }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                  }), 128))
                                ]),
                                _hoisted_113
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.cpu_loading]
                            ]),
                            _withDirectives(_createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_114, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_list_freq, (item, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: index,
                                      style: {
                            background: item.color,
                            width: item.width,
                          }
                                    }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                  }), 128))
                                ]),
                                _hoisted_115
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.cpu_loading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "详细数据",
                          name: "third_cpu"
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode("table", _hoisted_116, [
                              _createVNode("thead", _hoisted_117, [
                                _createVNode("tr", null, [
                                  _hoisted_118,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params_cpu, (item) => {
                                    return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.name), 1))
                                  }), 128))
                                ])
                              ]),
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_usage_data, (v) => {
                                  return (_openBlock(), _createBlock("tr", { key: v }, [
                                    _createVNode("td", null, _toDisplayString(v.label), 1),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params_cpu, (item) => {
                                      return (_openBlock(), _createBlock("td", { key: item }, [
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_color(item.value, v.new[item.value])[0]
                              
                                        }, _toDisplayString(v.new[item.value]), 5),
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_color(
                                  item.value,
                                  v.new[item.value],
                                  v.old[item.value]
                                )[1]
                              
                                        }, "(" + _toDisplayString(_ctx.getNum(v.new[item.value], v.old[item.value])) + ")", 5)
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ], 512), [
                              [_directive_loading, _ctx.cpu_loading]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.cpu_thead_options?.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_119, [
                          _hoisted_120
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cpu_thead_options?.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_form, {
                          key: 2,
                          style: {"margin-top":"20px"},
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "CPU核心" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.cpu_thread,
                                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.cpu_thread = $event)),
                                  placeholder: "请选择",
                                  onChange: _ctx.cpu_thead_change
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_thead_options, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: 'CPU' + item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.cpu_thead_options?.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_tabs, {
                          key: 3,
                          type: "card",
                          class: "demo-tabs spacName",
                          modelValue: _ctx.cpu_thread_activeName,
                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.cpu_thread_activeName = $event)),
                          onTabClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.handleClick_fps('cpu_thread')))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_tab_pane, {
                              label: "迭代趋势",
                              name: "first_cpu_thread",
                              style: {"padding":"10px"}
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_card, null, {
                                  default: _withId(() => [
                                    _hoisted_121
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_tab_pane, {
                              label: "局内趋势",
                              name: "second_cpu_thread",
                              style: {"padding":"10px"}
                            }, {
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_card, {
                                  style: {"position":"relative","width":"100%"},
                                  class: "spacName"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_122, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpuThread_list, (item, index) => {
                                        return (_openBlock(), _createBlock("div", {
                                          key: index,
                                          style: {
                            background: item.color,
                            width: item.width,
                          }
                                        }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                      }), 128))
                                    ]),
                                    _hoisted_123
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_directive_loading, _ctx.gpu_loading]
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_tab_pane, {
                              label: "详细数据",
                              name: "third_cpu_thread"
                            }, {
                              default: _withId(() => [
                                _withDirectives(_createVNode("table", _hoisted_124, [
                                  _createVNode("thead", _hoisted_125, [
                                    _createVNode("tr", null, [
                                      _hoisted_126,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thrad_list_head, (item) => {
                                        return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  _createVNode("tbody", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thrad_list_data, (v) => {
                                      return (_openBlock(), _createBlock("tr", { key: v }, [
                                        _createVNode("td", null, _toDisplayString(v.label_name), 1),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thrad_list_head, (item) => {
                                          return (_openBlock(), _createBlock("td", { key: item }, [
                                            _createVNode("span", null, _toDisplayString(v.new[item]), 1),
                                            _createVNode("span", null, "(" + _toDisplayString(_ctx.getNum(v.new[item], v.old[item])) + ")", 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    }), 128))
                                  ])
                                ], 512), [
                                  [_directive_loading, _ctx.gpu_loading]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("div", _hoisted_127, [
                      _hoisted_128,
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        style: {"margin-left":"20px"},
                        onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.configurationShow = true))
                      }, {
                        default: _withId(() => [
                          _hoisted_129
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, _ctx.localProject != 34]
                    ]),
                    _withDirectives(_createVNode(_component_el_tabs, {
                      type: "card",
                      class: "demo-tabs spacName",
                      modelValue: _ctx.gpu_activeName,
                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.gpu_activeName = $event)),
                      onTabClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.handleClick_fps('gpu')))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "迭代趋势",
                          name: "first_gpu",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _withDirectives(_createVNode("div", _hoisted_130, null, 512), [
                                  [_directive_loading, _ctx.gpu_loading]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "局内趋势",
                          name: "second_gpu",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_131, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gpu_list, (item, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: index,
                                      style: {
                            background: item.color,
                            width: item.width,
                          }
                                    }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                  }), 128))
                                ]),
                                _hoisted_132
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.gpu_loading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "详细数据",
                          name: "third_gpu"
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode("table", _hoisted_133, [
                              _createVNode("thead", _hoisted_134, [
                                _createVNode("tr", null, [
                                  _hoisted_135,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params_gpu, (item) => {
                                    return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.name), 1))
                                  }), 128))
                                ])
                              ]),
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_usage_data, (v) => {
                                  return (_openBlock(), _createBlock("tr", { key: v }, [
                                    _createVNode("td", null, _toDisplayString(v.label), 1),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params_gpu, (item) => {
                                      return (_openBlock(), _createBlock("td", { key: item }, [
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_color(item.value, v.new[item.value])[0]
                              
                                        }, _toDisplayString(v.new[item.value]), 5),
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_color(
                                  item.value,
                                  v.new[item.value],
                                  v.old[item.value]
                                )[1]
                              
                                        }, "(" + _toDisplayString(_ctx.getNum(v.new[item.value], v.old[item.value])) + ")", 5)
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ], 512), [
                              [_directive_loading, _ctx.gpu_loading]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]), [
                      [_vShow, _ctx.localProject != 34]
                    ]),
                    _createVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        style: {"margin-left":"20px"},
                        onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.configurationShow = true))
                      }, {
                        default: _withId(() => [
                          _hoisted_138
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_el_tabs, {
                      type: "card",
                      class: "demo-tabs spacName",
                      modelValue: _ctx.thread_activeName,
                      "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (_ctx.thread_activeName = $event)),
                      onTabClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.handleClick_fps('thread')))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "迭代趋势",
                          name: "first_thread",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _withDirectives(_createVNode("div", _hoisted_139, null, 512), [
                                  [_directive_loading, _ctx.thread_loading]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "局内趋势",
                          name: "second_thread",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_140, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thread_list, (item, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: index,
                                      style: {
                            background: item.color,
                            width: item.width,
                          }
                                    }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                  }), 128))
                                ]),
                                _hoisted_141
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.thread_loading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "详细数据",
                          name: "third_thrad"
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode("table", _hoisted_142, [
                              _createVNode("thead", _hoisted_143, [
                                _createVNode("tr", null, [
                                  _hoisted_144,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overList, (item) => {
                                    return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(_ctx.getChinese(item)), 1))
                                  }), 128))
                                ])
                              ]),
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overviewData, (item, index) => {
                                  return (_openBlock(), _createBlock("tr", { key: index }, [
                                    _createVNode("td", null, _toDisplayString(item.label_name), 1),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overList, (i, k) => {
                                      return (_openBlock(), _createBlock("td", { key: k }, [
                                        _createVNode("span", {
                                          style: 'color:' + _ctx.com_color(i, item.new[i])[0]
                                        }, _toDisplayString(item.new[i]), 5),
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_color(i, item.new[i], item.old[i])[1]
                              
                                        }, "(" + _toDisplayString(_ctx.getNum(item.new[i], item.old[i])) + ")", 5)
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ], 512), [
                              [_directive_loading, _ctx.thread_loading]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        style: {"margin-left":"20px"},
                        onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.configurationShow = true))
                      }, {
                        default: _withId(() => [
                          _hoisted_147
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_el_tabs, {
                      type: "card",
                      class: "demo-tabs spacName",
                      modelValue: _ctx.activeName_moudle,
                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.activeName_moudle = $event)),
                      onTabClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.handleClick_fps('moudle')))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "迭代趋势",
                          name: "first_moudle",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "指标选择" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.moudle_iteration_model,
                                      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.moudle_iteration_model = $event)),
                                      multiple: "",
                                      onChange: _ctx.moduleChange_iteration,
                                      "collapse-tags": "",
                                      placeholder: "Select",
                                      style: {"width":"240px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.handleSelectAll2('close', '迭代')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_148
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.handleSelectAll2('open', '迭代')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_149
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudleIterationList, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _withDirectives(_createVNode("div", _hoisted_150, null, 512), [
                                  [_directive_loading, _ctx.moudle_loading]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "局内趋势",
                          name: "second_moudle",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "指标选择" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.moudle_model,
                                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.moudle_model = $event)),
                                      multiple: "",
                                      onChange: _ctx.moduleChange,
                                      "collapse-tags": "",
                                      placeholder: "Select",
                                      style: {"width":"240px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.handleSelectAll2('close', '局内')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_151
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.handleSelectAll2('open', '局内')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_152
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudleList, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_153, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle_list, (item, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: index,
                                      style: {
                            background: item.color,
                            width: item.width,
                          }
                                    }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                  }), 128))
                                ]),
                                _withDirectives(_createVNode("div", _hoisted_154, null, 512), [
                                  [_directive_loading, _ctx.moudle_loading]
                                ])
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.moudle_loading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "详细数据",
                          name: "third_moudle"
                        }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_155, [
                              _withDirectives(_createVNode(_component_el_table, {
                                style: {"flex":"2"},
                                id: "moudle_scroll",
                                class: "spacName",
                                size: "mini",
                                border: "",
                                "header-cell-style": {
                          background: '#5D99D5',
                          color: '#fff',
                        },
                                "cell-style": _ctx.cellStyle,
                                data: _ctx.function_list_data
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_table_column, {
                                    width: "800",
                                    "show-overflow-tooltip": true
                                  }, {
                                    header: _withId(() => [
                                      _hoisted_156
                                    ]),
                                    default: _withId((scope) => [
                                      _createVNode("span", {
                                        style: 
                                'margin-left:' + _ctx.depth(scope.row.depth) + 'px'
                              
                                      }, _toDisplayString(scope.row.name), 5)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["cell-style", "data"]), [
                                [_directive_loading, _ctx.moudle_loading]
                              ]),
                              _withDirectives(_createVNode(_component_el_table, {
                                style: {"flex":"1"},
                                id: "moudle_scroll",
                                class: "spacName",
                                size: "mini",
                                border: "",
                                "header-cell-style": {
                          background: '#5D99D5',
                          color: '#fff',
                        },
                                "cell-style": _ctx.cellStyle,
                                data: _ctx.function_list_data
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.function_label_list?.slice(
                            0,
                            1
                          ), (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      align: "center",
                                      label: item,
                                      key: index
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          width: "150",
                                          label: "耗时"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", {
                                              style: 
                                  'color:' +
                                  _ctx.com_color(
                                    scope.row.type,
                                    scope.row.list[index].event_count,
                                    scope.row.list[index].old_event_count
                                  )[0]
                                
                                            }, _toDisplayString(typeof scope.row.list[index].event_count ==
                                  "number"
                                    ? scope.row.list[index].event_count.toFixed(
                                        2
                                      )
                                    : "--"), 5),
                                            _createVNode("span", {
                                              style: 
                                  'color:' +
                                  _ctx.com_color(
                                    scope.row.type,
                                    scope.row.list[index].event_count,
                                    scope.row.list[index].old_event_count
                                  )[1]
                                
                                            }, "(" + _toDisplayString(_ctx.getNum(
                                    scope.row.list[index].event_count,
                                    scope.row.list[index].old_event_count
                                  )) + ")", 5)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (
                              _ctx.function_label_list?.slice(
                                1,
                                _ctx.function_label_list?.length
                              ).length <= 3
                            )
                                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                                              key: 0,
                                              width: "150",
                                              label: "比例"
                                            }, {
                                              default: _withId((scope) => [
                                                _createVNode("span", null, _toDisplayString(typeof scope.row.list[index].rate == "number"
                                  ? scope.row.list[index].rate.toFixed(2) + "%"
                                  : "--"), 1),
                                                _createVNode("span", null, "(" + _toDisplayString(_ctx.getNum(
                                    scope.row.list[index].rate,
                                    scope.row.list[index].old_rate
                                  ) != "--"
                                    ? _ctx.getNum(
                                        scope.row.list[index].rate,
                                        scope.row.list[index].old_rate
                                      )
                                    : "--") + ")", 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["cell-style", "data"]), [
                                [_directive_loading, _ctx.moudle_loading]
                              ]),
                              (_ctx.function_label_list?.length > 1)
                                ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                                    key: 0,
                                    style: {"flex":"3"},
                                    id: "moudle_scroll",
                                    class: "spacName",
                                    size: "mini",
                                    border: "",
                                    "header-cell-style": {
                          background: '#5D99D5',
                          color: '#fff',
                        },
                                    "cell-style": _ctx.cellStyle,
                                    data: _ctx.function_list_data
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.function_label_list?.slice(
                            1,
                            _ctx.function_label_list?.length
                          ), (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                          width: "200",
                                          align: "center",
                                          label: item,
                                          key: index
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_table_column, {
                                              width: 
                              _ctx.function_label_list?.slice(
                                1,
                                _ctx.function_label_list?.length
                              ).length <= 3
                                ? 150
                                : 250
                            ,
                                              label: "耗时"
                                            }, {
                                              default: _withId((scope) => [
                                                _createVNode("span", {
                                                  style: 
                                  'color:' +
                                  _ctx.com_color(
                                    scope.row.type,
                                    scope.row.list[index + 1].event_count,
                                    scope.row.list[index + 1].old_event_count
                                  )[0]
                                
                                                }, _toDisplayString(typeof scope.row.list[index + 1]
                                    .event_count == "number"
                                    ? scope.row.list[
                                        index + 1
                                      ].event_count.toFixed(2)
                                    : "--"), 5),
                                                _createVNode("span", {
                                                  style: 
                                  'color:' +
                                  _ctx.com_color(
                                    scope.row.type,
                                    scope.row.list[index + 1].event_count,
                                    scope.row.list[index + 1].old_event_count
                                  )[1]
                                
                                                }, "(" + _toDisplayString(_ctx.getNum(
                                    scope.row.list[index + 1].event_count,
                                    scope.row.list[index + 1].old_event_count
                                  )) + ")", 5)
                                              ]),
                                              _: 2
                                            }, 1032, ["width"]),
                                            (
                              _ctx.function_label_list?.slice(
                                1,
                                _ctx.function_label_list?.length
                              ).length <= 3
                            )
                                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                                  key: 0,
                                                  width: "150",
                                                  label: "比例"
                                                }, {
                                                  default: _withId((scope) => [
                                                    _createVNode("span", null, _toDisplayString(typeof scope.row.list[index + 1].rate ==
                                "number"
                                  ? scope.row.list[index + 1].rate.toFixed(2) +
                                    "%"
                                  : "--"), 1),
                                                    _createVNode("span", null, "(" + _toDisplayString(_ctx.getNum(
                                    scope.row.list[index + 1].rate,
                                    scope.row.list[index + 1].old_rate
                                  ) != "--"
                                    ? _ctx.getNum(
                                        scope.row.list[index + 1].rate,
                                        scope.row.list[index + 1].old_rate
                                      )
                                    : "--") + ")", 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["cell-style", "data"])), [
                                    [_directive_loading, _ctx.moudle_loading]
                                  ])
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _hoisted_157,
                    _createVNode("div", _hoisted_158, [
                      _createVNode("div", _hoisted_159, [
                        _createVNode("div", _hoisted_160, [
                          _createVNode("div", _hoisted_161, [
                            _createVNode("p", _hoisted_162, [
                              _hoisted_163,
                              _createVNode("span", _hoisted_164, _toDisplayString(_ctx.framesInfo_all.framesCount * _ctx.frame_merge_size), 1),
                              _hoisted_165,
                              _createVNode("span", _hoisted_166, _toDisplayString((_ctx.framesInfo_all.sumTime * _ctx.frame_merge_size).toFixed(
                              2
                            )), 1),
                              _hoisted_167,
                              _createVNode("span", _hoisted_168, _toDisplayString(_ctx.framesInfo_all.FPS), 1),
                              _hoisted_169,
                              _createVNode("span", _hoisted_170, _toDisplayString(_ctx.framesInfo_all.frameTime), 1),
                              _hoisted_171
                            ]),
                            _createVNode("p", _hoisted_172, [
                              _hoisted_173,
                              _createVNode("span", _hoisted_174, _toDisplayString(_ctx.framesInfo.framesCount * _ctx.frame_merge_size), 1),
                              _hoisted_175,
                              _createVNode("span", _hoisted_176, _toDisplayString(_ctx.framesInfo.start * _ctx.frame_merge_size) + "-" + _toDisplayString((_ctx.framesInfo.end + 1) * _ctx.frame_merge_size), 1),
                              _hoisted_177,
                              _createVNode("span", _hoisted_178, _toDisplayString((_ctx.framesInfo.sumTime * _ctx.frame_merge_size).toFixed(2)), 1),
                              _hoisted_179,
                              _createVNode("span", _hoisted_180, _toDisplayString(_ctx.framesInfo.FPS), 1),
                              _hoisted_181,
                              _createVNode("span", _hoisted_182, _toDisplayString(_ctx.framesInfo.frameTime), 1),
                              _hoisted_183
                            ]),
                            (_ctx.selectShow)
                              ? (_openBlock(), _createBlock("p", _hoisted_184, [
                                  _hoisted_185,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList, (item, index) => {
                                    return (_openBlock(), _createBlock("span", { key: index }, [
                                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                      _createVNode("span", _hoisted_186, _toDisplayString(item.sum.toFixed(2)), 1),
                                      _createVNode("span", null, _toDisplayString(index == _ctx.selectList?.length - 1 ? "" : "，"), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.btnFalse)
                          ? (_openBlock(), _createBlock("div", _hoisted_187, [
                              _createVNode(_component_el_form, {
                                inline: true,
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, { label: "卡顿问题" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        onChange: _ctx.problemChange_title,
                                        modelValue: _ctx.caton_title,
                                        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_ctx.caton_title = $event))
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catonList, (item, k) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: k,
                                              label: item.title,
                                              value: item.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["onChange", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, null, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.brushEnd())),
                                        type: "primary",
                                        size: "mini",
                                        disabled: _ctx.creatbtn
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_188
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, null, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        onClick: _ctx.deleCato,
                                        type: "primary",
                                        size: "mini"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_189
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_190, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: index,
                                  style: {
                            background: item.color,
                            width: item.width,
                          }
                                }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                              }), 128))
                            ]),
                            _hoisted_191
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_el_dialog, {
                        modelValue: _ctx.historyShow,
                        "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => (_ctx.historyShow = $event)),
                        width: "50%"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_card, null, {
                            default: _withId(() => [
                              _hoisted_192
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode("div", _hoisted_193, [
                        _createVNode("div", _hoisted_194, [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _ctx.submit
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_195
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    onKeyup: _withKeys(_ctx.serchChange_enter, ["enter"]),
                                    modelValue: _ctx.inputValue,
                                    "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => (_ctx.inputValue = $event))
                                  }, null, 8, ["onKeyup", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _withDirectives(_createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    onKeyup: _withKeys(_ctx.serchChange_enter, ["enter"]),
                                    modelValue: _ctx.inputValue,
                                    "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => (_ctx.inputValue = $event))
                                  }, null, 8, ["onKeyup", "modelValue"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, false]
                              ]),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.close1(_ctx.stackData, _ctx.state)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_196
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode(_component_el_table, {
                          id: "func",
                          border: "",
                          class: "customer-table2",
                          onRowClick: _ctx.handleRowClick,
                          "default-expand-all": _ctx.isExpand,
                          data: _ctx.stackData_all,
                          size: "small",
                          "header-cell-class-name": _ctx.headerCellClassName,
                          "header-cell-style": {
                        background: '#1B1B1B',
                        color: '#B5B5B5',

                        padding: '1px,0',
                        height: '10px',
                      },
                          ref: "table",
                          style: {"width":"100%","margin-bottom":"20px"},
                          "row-key": "id"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              "show-overflow-tooltip": true,
                              label: "func_name"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  id: scope.row.id
                                }, _toDisplayString(scope.row.name), 9, ["id"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              "show-overflow-tooltip": true,
                              align: "center",
                              label: "选中区域耗时(ms)",
                              width: "140",
                              prop: "value"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.value.toFixed(2)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "占比",
                              width: "140"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", _hoisted_197, [
                                  _createVNode("div", {
                                    style: 
                                'height:35px;background: linear-gradient(to right, #8AAAD4, white);;width:' +
                                scope.row.rate +
                                '%'
                              
                                  }, null, 4),
                                  _createVNode("div", {
                                    style: 
                                'height:35px;background:#fff;width:' +
                                (100 - Number(scope.row.rate)) +
                                '%'
                              
                                  }, null, 4),
                                  _createVNode("div", _hoisted_198, _toDisplayString(scope.row.rate + "%"), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "对比整局(ms)",
                              width: "140",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", null, _toDisplayString(_ctx.diffValue(
                                scope.row.value,
                                _ctx.func_list[scope.row.id]?.value
                              )), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "对比上版本(ms)",
                              width: "140",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", null, _toDisplayString(_ctx.diffValue(
                                scope.row.value,
                                _ctx.func_list[scope.row.id]?.old_value
                              )), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "140",
                              align: "center",
                              label: "整局平均耗时(ms)"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(_ctx.func_list[scope.row.id]?.value
                              ? _ctx.func_list[scope.row.id]?.value.toFixed(2)
                              : ""), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "difference",
                              label: "历史趋势",
                              width: "100",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  onClick: ($event: any) => (
                              _ctx.view_trend(scope.row.name, scope.row.thread)
                            ),
                                  style: {"cursor":"pointer","color":"#61c3e4"}
                                }, "查看", 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "80",
                              align: "center",
                              label: "曲线"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_checkbox, {
                                  modelValue: scope.row.check,
                                  "onUpdate:modelValue": ($event: any) => (scope.row.check = $event),
                                  onChange: ($event: any) => (_ctx.look(scope.row))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onRowClick", "default-expand-all", "data", "header-cell-class-name"]), [
                          [_directive_loading, _ctx.flame_loading]
                        ])
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_199, [
                          _createVNode("div", _hoisted_200, [
                            _createVNode(_component_el_input, {
                              size: "mini",
                              modelValue: _ctx.func_name,
                              "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (_ctx.func_name = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createVNode("div", _hoisted_201, [
                            _createVNode(_component_el_input, {
                              size: "mini",
                              modelValue: _ctx.func_rate,
                              "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (_ctx.func_rate = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createVNode("div", _hoisted_202, [
                            _createVNode("div", _hoisted_203, [
                              _createVNode(_component_el_input, {
                                style: {"margin-right":"20px"},
                                modelValue: _ctx.flame_serch,
                                "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => (_ctx.flame_serch = $event)),
                                placeholder: "搜索",
                                "prefix-icon": "el-icon-search",
                                size: "mini"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "mini",
                                onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.recordSearch()))
                              }, {
                                default: _withId(() => [
                                  _hoisted_204
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_205, [
                          _createVNode(_component_el_tabs, {
                            type: "card",
                            class: "demo-tabs spacName tabs_color",
                            modelValue: _ctx.flame_name,
                            "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.flame_name = $event)),
                            onTabClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.handleClick_flame(_ctx.flame_name)))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.flame_thead_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                  key: item,
                                  label: item,
                                  name: item,
                                  style: {"padding":"10px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_206, [
                                      _createVNode("div", {
                                        id: _ctx.replaceSpacesWithHyphens(item),
                                        class: "chart-area"
                                      }, null, 8, ["id"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "name"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ], 512)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_207, [
            _createVNode(_component_el_tree, {
              "node-class": _ctx.nodeClass,
              class: "floating-tree",
              data: _ctx.treeData,
              props: _ctx.defaultProps,
              accordion: "",
              "default-expand-all": "",
              onNodeClick: _ctx.handleNodeClick
            }, null, 8, ["node-class", "data", "props", "onNodeClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})